'use strict';

/**
 * @ngdoc function
 * @name ribytRsvpApp.controller:AboutCtrl
 * @description
 * # AboutCtrl
 * Controller of the ribytRsvpApp
 */
angular.module( 'ribytRsvpApp' )
    .controller( 'ItineraryCtrl', ['$scope', '$rootScope', 'lodash', 'ENV', '$timeout', '$http', 'notificationService', '$sessionStorage', 'variableSubstitution', '$sce', 'moment', function ( $scope, $rootScope, _, ENV, $timeout, $http, notificationService, $sessionStorage, $variableSubstitution, $sce, moment ) {
        var invite = $rootScope.decryptInvite( _.get( $sessionStorage, 'invitation' ) );
        $rootScope.bannerImage = true;
        $rootScope.isTicketPage = false;
        $rootScope.isLandingPage = false;

        if ( _.get( $sessionStorage, 'preview' ) ) {
            $rootScope.preview = true;
        }

        if ( _.get( $rootScope, 'parameters.invite' ) ) {
            invite = $rootScope.decryptInvite( _.get( $rootScope, 'parameters.invite', null ) );
        }

        // prepare PDF url stuff
        var fileName = [
            _.get( invite, 'guestID.name.first' ),
            _.get( invite, 'guestID.name.last' ),
            _.get( invite, 'eventID.name' )
        ].join( '_' );

        var url = 'https://pdfmyurl.com/api?license=' + _.get( ENV, 'pdfmyurlKey', 'xzgOom2eSHLG' ) + '&url=' +
            encodeURIComponent( window.location.origin + '/#/itinerary?inviteHash=' ) +
            encodeURIComponent( _.get( invite, 'inviteHash' ) ) +
            '&preview=' + encodeURIComponent( _.get( invite, 'id' ) ) +
            'download=true&orientation=portrait&filename=' + encodeURIComponent( fileName );

        $rootScope.pdfUrl = url;
        $rootScope.hideTabs = true;

        // only go through if we have an invite
        if ( invite && invite.byts.length > 0 ) {
            // remove byts that are not enabled
            _.remove( invite.byts, function eachByt ( n ) {
                // this would remove the byt if n.isAccepted === false or n.isEnabled === false - ns
                // to account for the guest declined hotel or air originally and then the host re-enables the byt, we needed to check for isAccepted=false and n.isEnabled=false to remove the byt
                // return (n.isEnabled === false) || (n.isAccepted === false && !n.isEnabled);
                return ( n.isEnabled === false || n.isAccepted === false );
            } );

            // remove byts that are not to be shown on itinerary
            _.remove( invite.byts, function eachByt ( n ) {
                // this would remove the byt if n.bytID.isShowOnItinerary === false - ns
                return ( _.get( n, 'bytID.isShowOnItinerary' ) === false );
            } );

            _.remove( invite.byts, function eachByt ( n ) {
                // this would remove byt if n.type === Ticket. We do not want to show tickets on itinerary page.
                return ( _.get( n, 'type' ) === 'Ticket' && !_.get( n, 'bytID.ticketDetails.isShowOnItinerary' ) );
            } );

            // talk to the api to get the PDF
            $rootScope.getPDF = function () {
                if ( !$rootScope.loadingPDF ) {
                    // show a loading spinner
                    $rootScope.loadingPDF = true;

                    notificationService.notice( 'Please wait while we generate your PDF.' );

                    $http( {
                        'url': _.get( ENV, 'apiEndpoint', 'http://localhost:1338' ) + '/ribyt/rsvp/' + _.get( $rootScope, 'inviteHash' ) + '/pdf',
                        'responseType': 'arraybuffer',
                        'method': 'GET'
                    } )
                        .then( function success ( response ) {
                            // hide the spinner
                            $rootScope.loadingPDF = false;

                            var file = new Blob( [response.data], {'type': 'application/pdf'} );
                            var fileURL = URL.createObjectURL( file );

                            if ( window.navigator.msSaveOrOpenBlob ) {
                                window.navigator.msSaveOrOpenBlob( file, 'Itinerary.pdf' );
                            } else {
                                window.open( fileURL );
                            }
                        }, function error () {
                            $rootScope.loadingPDF = false;
                            notificationService.error( 'There was an error generating the PDF.' );
                        } );
                }
            };
            $rootScope.getICS = function () {
                window.open( _.get( ENV, 'apiEndpoint', 'http://localhost:1338' ) + '/ribyt/rsvp/' + _.get( $rootScope, 'inviteHash' ) + '/ics' );
            };

            // only show the ics 5 days before the first group date start
            var daysToRevealICS = 5;
            var groupStartDate = moment.utc( _.get( invite, 'experienceID.dateStart' ) ).format( 'YYYY-MM-DD' );
            var currentDateTime = moment().format( 'YYYY-MM-DD HH:mm:ss' );

            if ( moment( groupStartDate ).diff( currentDateTime, 'hours' ) <= ( 24 * daysToRevealICS ) ) {
                $rootScope.showICSButton = true;
            }

            $rootScope.showPDFButton = true;
            // put the correct value to sort by in a new variable start, depending on legs
            $scope.sortAndSet = function ( byts ) {
                _.each( byts, function ( byt ) {
                    if ( byt.type === 'Hotel' ) {
                        /**
                         * Hotel is wonky since we don't know the checkin date at time of creation
                         * but we do know the time of checkin. If the host does not enter a confirmation
                         * number or save the guest management hotel byt in any way, then the
                         * bytDetails is effectively empty. Thus we have to compensate here
                         * and pull the package date but the hotel byt time and merge them as is
                         * normally done in the guest management page.
                         */

                        // By default, it should appear as group start date and group end date as the DEFAULT check-on and check-out dates, RPT-1987.
                        if ( !_.get( byt, 'bytDetails.datetimeCheckIn' ) ) {
                            byt.bytDetails.datetimeCheckIn = moment.utc( invite.experienceID.dateStart ).format( 'YYYY-MM-DD ' ) + moment.utc( byt.bytID.datetimeStart ).format( 'HH:mm:ss' );
                        }
                        if ( !_.get( byt, 'bytDetails.datetimeCheckOut' ) ) {
                            byt.bytDetails.datetimeCheckOut = moment.utc( invite.experienceID.dateEnd ).format( 'YYYY-MM-DD ' ) + moment.utc( byt.bytID.datetimeEnd ).format( 'HH:mm:ss' );
                        }

                        // this will give the byt a start value. if there is no value, it needs to have a date to show up on itinerary. it will just be today's date
                        byt.start = byt.bytDetails.datetimeCheckIn || moment.utc( invite.experienceID.dateStart ).format( 'YYYY-MM-DD' );
                    } else if ( ( byt.type === 'Air' ) || ( byt.type === 'Train' ) ) {
                        var earliestDate = null;
                        _.each( _.get( byt, 'bytDetails.legs', [] ), function ( leg ) {
                            if ( leg.type === 'departure' && leg.flightNumber ) {
                                if ( !earliestDate || new Date(leg.datetimeDeparture) < new Date(earliestDate) ) {
                                    earliestDate = leg.datetimeDeparture;
                                }
                                byt.start = earliestDate;
                            }
                        } );
                    } else if ( byt.type === 'Ground' ) {
                        if ( !_.get( byt, 'bytDetails.datetimeStart' ) || _.get( byt, 'bytDetails.datetimeStart' ) === 'Invalid date' ) {
                            byt.bytDetails.datetimeStart = byt.bytID.datetimeStart;
                            byt.invalidDate = true;
                        }
                        if (_.get( byt, 'bytID.bytDetails.direction' ) === 'neither') {
                            if (_.get( byt, 'bytDetails.datetimeStart' )) {
                                byt.start = byt.bytDetails.datetimeStart;
                            } else {
                                byt.start = _.get( byt, 'bytID.datetimeStart' );
                            }
                        } else {
                            byt.start = byt.bytDetails.datetimeStart;
                        }
                    } else if ( byt.type === 'Activity' ) {
                        byt.start = byt.datetimeStart;
                    } else if ( byt.type === 'Ticket' ) {
                        byt.start = byt.bytID.datetimeStart;
                        byt.datetimeStart = byt.bytID.datetimeStart;
                        byt.datetimeEnd = byt.bytID.datetimeEnd;
                        byt.bytID.description = _.get( byt, 'bytID.ticketDetails.itineraryDetails' );
                    } else if ( byt.type === 'Bonus' ) {
                        byt.start = false;
                    } else {
                        // if activity or other type
                        byt.start = _.get( byt, 'bytID.datetimeStart' );
                    }

                    if ( byt.start ) {
                        if ( byt.start.trim().length > 25 ) {
                            byt.start = moment( moment( byt.start ).utc().format( 'ddd MMM DD YYYY HH:mm:ss' ) ).toDate( );
                        } else {
                            byt.start = moment.utc( byt.start ).toDate();
                        }
                    }
                    byt.multiDays = byt.datetimeStart && byt.datetimeEnd && !moment( byt.datetimeStart ).isSame( moment( byt.datetimeEnd ), 'day' );
                } );
                return byts;
            }

            // Sort byt date
            invite.byts = $scope.sortAndSet( invite.byts );

            var orderedByts = _.sortBy( invite.byts, 'start' );
            var groupedByts = {};
            var airByt = null;
            var airDepartureLegs = [];
            var airArrivalLegs = [];
            var airDepartureLegsCount = [];
            var generalGround = [];
            var bonusByts = [];

            $scope.invite = invite;
            $rootScope.setHeaderBanner(invite, 'itinerary');

            // track for displaying the order
            var has = {
                'groundArrival': false,
                'groundDeparture': false,
                'hotel': false,
                'airArrival': false,
                'airDeparture': false
            };

            // Group the byts into date order
            _.each( orderedByts, function ( byt, i ) {
                if ( byt.type !== 'Ticket' ) {
                    // bring isAllowDecline to this copy of the byt so we can use it in the view
                    var experienceByt = _.find( _.get( invite, 'experienceID.byts' ), function ( bytExp ) {
                        return _.get( byt, 'bytID.id' ) === bytExp.bytID;
                    } );

                    if ( _.get( experienceByt, 'isAllowDecline' ) ) {
                        byt.isAllowDecline = experienceByt.isAllowDecline;
                    }
                }

                if ( byt.type === 'Air' ) {
                    // separate the flight into legs, but maintain the original byt. So this will look like
                    // the regular byt, but with only one leg under byt.bytDetails.legs
                    airByt = _.clone( byt );
                    if ( _.get( byt, 'bytID.bytDetails.legs' ) === 'Round-trip' ) {
                        airDepartureLegsCount = airDepartureLegs.length;
                        // NOTE: return on FE is departure on our backend
                        _.each( _.get( airByt, 'bytDetails.legs', [] ), function ( leg ) {
                            if ( leg.type == 'return' && leg.flightNumber ) {
                                var temp = _.cloneDeep( byt );
                                temp.bytDetails.legs = leg;
                                temp.startWithTZ = moment.tz( leg.datetimeDeparture, leg.departureVenue.timeZoneRegionName ).toDate();
                                temp.start = moment( leg.datetimeDeparture ).toDate()//.format( 'YYYY-MM-DD HH:mm:ss' );

                                // put the byt in the appropriate groupedByts section
                                var key = new moment( leg.datetimeDeparture ).format( 'YYYY-MM-DD' );

                                if ( _.has( groupedByts, key ) ) {
                                    groupedByts[key].push( temp );
                                } else {
                                    groupedByts[key] = [temp];
                                }
                                airDepartureLegs.push( temp );
                                has.airDeparture = temp;
                            } else if ( leg.type == 'departure' && leg.flightNumber ) {
                                var temp = _.cloneDeep( byt );
                                temp.bytDetails.legs = leg;
                                temp.startWithTZ = moment.tz( leg.datetimeDeparture, leg.departureVenue.timeZoneRegionName ).toDate();
                                temp.start = moment.utc( leg.datetimeDeparture ).toDate()//.format( 'YYYY-MM-DD HH:mm:ss' );

                                // put the byt in the appropriate groupedByts section
                                var key = new moment( leg.datetimeDeparture ).format( 'YYYY-MM-DD' );

                                if ( _.has( groupedByts, key ) ) {
                                    groupedByts[key].push( temp );
                                } else {
                                    groupedByts[key] = [temp];
                                }
                                airArrivalLegs.push( temp );
                                has.airArrival = temp;
                            }
                        } );

                        _.pullAt( invite.byts, i );
                    } else {
                        _.each( _.get( airByt, 'bytDetails.legs', [] ), function ( leg ) {
                            if ( _.get( leg, 'flightNumber', false ) ) {
                                var temp = _.cloneDeep( byt );
                                temp.bytDetails.legs = leg;
                                temp.startWithTZ = moment.tz( leg.datetimeDeparture, leg.departureVenue.timeZoneRegionName ).toDate();
                                temp.start = moment.utc( leg.datetimeDeparture ).toDate();

                                byt.start = moment.utc( leg.datetimeDeparture ).toDate();
                                var key = new moment( leg.datetimeDeparture ).format( 'YYYY-MM-DD' );
                                if ( _.has( groupedByts, key ) ) {
                                    groupedByts[key].push( temp );
                                } else {
                                    groupedByts[key] = [temp];
                                }
                                has.airArrival = temp;

                                _.pullAt( invite.byts, i );
                            }
                        } );
                    }
                } else if ( byt.type === 'Ground' ) {
                    switch ( _.get( byt, 'bytID.bytDetails.direction' ) ) {
                        case 'departure':
                            has.groundDeparture = _.cloneDeep( byt );
                            break;
                        case 'arrival':
                            has.groundArrival = _.cloneDeep( byt );
                            break;
                        case 'neither':
                            generalGround.push( _.clone( byt ) );
                            break;
                        default:
                        // Not sure for now.
                    }

                    if ( _.get( byt, 'bytID.bytDetails.direction' ) === 'neither' ) {
                        var key = moment.utc( byt.start || byt.bytID.datetimeStart ).format( 'YYYY-MM-DD' );
                        if ( _.has( groupedByts, key ) ) {
                            groupedByts[key].push( byt );
                        } else {
                            groupedByts[key] = [byt];
                        }
                    }
                } else if ( byt.type === 'Hotel' && byt.isEnabled ) {
                    var key = ( new moment( byt.bytDetails.datetimeCheckIn ) || moment.utc( invite.experienceID.dateStart ) ).format( 'YYYY-MM-DD' );
                    if ( _.has( groupedByts, key ) ) {
                        groupedByts[key].push( byt );
                    } else {
                        groupedByts[key] = [byt];
                    }
                    if ( !has.hotel || has.hotel.start > byt.start ) {
                        has.hotel = byt;
                    }
                } else { // if activity and other byts
                    if ( byt.start ) {
                        var key = moment.utc( byt.start ).format( 'YYYY-MM-DD' );

                        if ( _.has( groupedByts, key ) ) {
                            groupedByts[key].push( byt );
                        } else {
                            groupedByts[key] = [byt];
                        }
                    } else {
                        // if there is no start, this is a bonus byt, we will keep them all in an array
                        bonusByts.push( byt );
                    }
                }
            } );

            // set the start property of any ground departure stuff here so it can be automatically adjusted in the itinerary
            // we needed to wait until we get all the flight leg info before we could set the start time
            if ( _.get( has, 'groundDeparture.bytID.bytDetails.pickupTime.length', '' ) > 1 && has.airDeparture ) {
                var timeAdjustmentInHours = has.groundDeparture.bytID.bytDetails.pickupTime.split( ' ' )[0];

                var earliestDepartureTime = null;
                _.each( airDepartureLegs, function ( leg ) {
                    if ( !earliestDepartureTime ) {
                        earliestDepartureTime = leg.bytDetails.legs.datetimeDeparture;
                    } else if ( _.get( leg, 'bytDetails.legs.datetimeDeparture' ) < earliestDepartureTime ) {
                        earliestDepartureTime = leg.bytDetails.legs.datetimeDeparture;
                    }
                } );
                has.groundDeparture.start = moment( earliestDepartureTime ).subtract( timeAdjustmentInHours, 'hour' ).toDate();
                var key = moment.utc( earliestDepartureTime ).subtract( timeAdjustmentInHours, 'hour' ).format( 'YYYY-MM-DD' );
                if ( _.has( groupedByts, key ) ) {
                    groupedByts[key].push( has.groundDeparture );
                } else {
                    groupedByts[key] = [has.groundDeparture];
                }
            }

            // reorder the byts becuase after a push from above, it may not be in order
            var reorderedGroupByts = _.keys( groupedByts ).sort();

            // create temp group byts
            var tempGroupedByts = {};
            _.each( reorderedGroupByts, function ( item ) {
                tempGroupedByts[item] = groupedByts[item];
            } );

            // set grouped byts to the temp reordered version
            groupedByts = tempGroupedByts;

            var bytsWithTimeTextStartOnly = {};
            // go through each date and reorder the byts in there
            _.each( groupedByts, function bytDateGroup ( date, key ) {
                // remove any byts that have time start text from the date group and return those byts
                var activityWithTimeStartTextOnly = _.remove( date, function ( byt ) {
                    // if there is no byt datetimeStart then check if there is time start text
                    if ( !_.get( byt, 'bytID.datetimeStart', false ) ) {
                        return _.get( byt, 'bytID.timeStartText', false );
                    } else { // if there is at least a date time start do not remove the byt
                        return false;
                    }
                } );

                // sort the remaining  byts in the group by start datetime
                var sortedByStart = _.sortBy( date, 'start' );

                // if there were byts with time start text hash them by groupedByt array index
                if ( activityWithTimeStartTextOnly ) {
                    bytsWithTimeTextStartOnly[key] = activityWithTimeStartTextOnly;
                }

                // add the newly sorted byts without the byts that have a date start text
                groupedByts[key] = sortedByStart;
            } );


            $scope.groupedByts = groupedByts;

            /** ****************************************************************
             REORDER hotel, arrival/departure ground, and flights
             reorder the arrival ground, you're here, hotel, and flight sections
             if we have a hotel, we base everything off of that
             *******************************************************************/

                // hello is the time the person is "here", after air, ground, and hotel checkin
            var hello = orderedByts.filter( function ( byt ) {
                    return byt.start && !byt.invalidDate;
                } )[0];
            if ( hello ) {
                hello = hello.start;
            } else {
                hello = _.get( invite, 'experienceID.dateStart' );
            }
            hello = moment.utc( hello ).format( 'YYYY-MM-DD' );

            // the following will sort the hotel, arrival ground, and air amongst each other
            if ( has.hotel ) {
                var hotelDate = new moment.tz( has.hotel.start, invite.eventID.location.timezone ).format( 'YYYY-MM-DD' );

                // NOTE if for some reason we want to keep hotel and air/ground together instead of chronologically, we need to uncomment the following, plus also search for '¯\_(ツ)_/¯'

                // get all the activities out
                var allActivities = _.remove( $scope.groupedByts[hotelDate], { 'type': 'Activity'} );
                allActivities = _.orderBy( allActivities, 'start', 'asc' );

                if ( has.airArrival ) {
                    if ( has.groundArrival ) {
                        // put the ground after air arrival
                        var key = moment.tz( has.airArrival.startWithTZ, has.airArrival.bytDetails.legs.departureVenue.timeZoneRegionName ).format( 'YYYY-MM-DD' );
                        var airPosition = _.findLastIndex( groupedByts[key], function ( element ) {
                            return element.type === 'Air' && element.bytDetails.legs.type === 'departure';
                        } );
                        if ( $scope.groupedByts[key] ) {
                            // if there is an activity, use the old stuff
                            var hasActivity = _.findLastIndex( $scope.groupedByts[key], { 'type': 'Activity' } );
                            if ( hasActivity >= 0 ) {
                                // add a start property to the ground using the arrival air arrival time
                                has.groundArrival.start = moment( has.airArrival.bytDetails.legs.datetimeArrival ).add( 1, 'minute' ).toDate();
                                // insert the ground arrival after the air
                                $scope.groupedByts[key].splice( airPosition + 1, 0, has.groundArrival );
                                // then place the hotel after the ground
                                var hotelPosition = _.findLastIndex( $scope.groupedByts[hotelDate], { 'type': 'Hotel' } );
                                var pulledHotel = _.pullAt( $scope.groupedByts[hotelDate], hotelPosition );
                                // find the position of the ground
                                var groundArrivalPosition = airPosition + 1;

                                if ( hotelDate === key ) {
                                    $scope.groupedByts[key].splice( groundArrivalPosition + 1, 0, pulledHotel[0] );
                                } else {
                                    // if they're not the same date, just put it in the right date, and it should sort on it's own
                                    $scope.groupedByts[hotelDate].push( has.hotel );
                                }
                            } else {
                                // remove the air
                                var pulledAir = _.pullAt( $scope.groupedByts[key], airPosition );

                                // put back everything in the order that we want it
                                has.groundArrival.start = moment( pulledAir[0].start ).add( 1, 'minutes' ).toDate();
                                $scope.groupedByts[key].push( pulledAir[0] );
                                $scope.groupedByts[key].push( has.groundArrival );

                                // only move the hotel if it's the same date as this current key date
                                if ( hotelDate === key ) {
                                    var hotelPosition = _.findLastIndex( $scope.groupedByts[hotelDate], { 'type': 'Hotel' } );
                                    var pulledHotel = _.pullAt( $scope.groupedByts[hotelDate], hotelPosition );
                                    $scope.groupedByts[key].push( pulledHotel[0] );
                                }
                            }
                        }
                    } else {
                        // there is no ground, but there is a hotel and air arrival
                        var key = moment.tz( has.airArrival.startWithTZ, has.airArrival.bytDetails.legs.departureVenue.timeZoneRegionName ).format( 'YYYY-MM-DD' );

                        if ( key === hotelDate ) {
                            var airPosition = _.findLastIndex( groupedByts[key], function ( element ) {
                                return element.type === 'Air' && element.bytDetails.legs.type === 'departure';
                            } );
                            var hotelPosition = _.findLastIndex( $scope.groupedByts[hotelDate], { 'type': 'Hotel' } );
                            var pulledHotel = _.pullAt( $scope.groupedByts[hotelDate], hotelPosition );

                            // place hotel after air
                            $scope.groupedByts[key].splice( airPosition + 1, 0, pulledHotel[0] );
                        }
                    }
                } else {
                    // there is no air, but they can have an arrival ground
                    // so put the ground before the hotel

                    var hotelPosition = _.findLastIndex( $scope.groupedByts[hotelDate], { 'type': 'Hotel' } );
                    var key = moment.utc( has.hotel.start ).format( 'YYYY-MM-DD' );

                    if ( has.groundArrival ) {
                        has.groundArrival.start = moment( has.hotel.start ).subtract( 1, 'minute' ).toDate();
                        // if the hotel is the first item, put the ground at the top of the array
                        if ( hotelPosition === 0 ) {
                            $scope.groupedByts[key].unshift( has.groundArrival );
                        } else {
                            // otherwise, put the ground before hotel
                            $scope.groupedByts[key].splice( hotelPosition - 1, 0, has.groundArrival );
                        }
                    }
                }

                // ¯\_(ツ)_/¯ comment out the follwing if we are going to keep air/ground/hotel together
                // also remove the sort ( $scope.groupedByts[hotelDate] = _.sortBy( $scope.groupedByts[hotelDate], 'start', 'asc' ); )

                // put all the activities back. if it is before hello, put it at the top. if it is after, put it at the end
                _.each( allActivities, function ( activity ) {
                    if ( moment.utc( activity.start ).isBefore( has.hotel.start ) ) {
                        $scope.groupedByts[hotelDate].unshift( activity );
                    } else {
                        $scope.groupedByts[hotelDate].push( activity );
                    }
                } );
                $scope.groupedByts[hotelDate] = _.sortBy( $scope.groupedByts[hotelDate], 'start', 'asc' );
            } else {
                // there is no hotel, but there may be a flight, so if we have a ground, attach that ground after the flight lands
                if ( has.airArrival ) {
                    var key = moment.tz( has.airArrival.startWithTZ, has.airArrival.bytDetails.legs.departureVenue.timeZoneRegionName ).format( 'YYYY-MM-DD' );

                    if ( has.groundArrival ) {
                        has.groundArrival.start = moment( has.airArrival.start ).add( 1, 'minute' ).toDate();
                        var airPosition = _.findLastIndex( groupedByts[key], function ( element ) {
                            return element.type === 'Air' && element.bytDetails.legs.type === 'departure';
                        } );
                        // insert the ground arrival after the air
                        $scope.groupedByts[key].splice( airPosition + 1, 0, has.groundArrival );
                    }
                } else if ( has.groundArrival ) {
                    // handle the ground arrival
                    // we want a list of all the dates in the itinerary
                    var keysOfGroupedByts = _.keys( $scope.groupedByts );
                    // so we need to remove 'Additonal Details' if it is in there
                    _.remove( keysOfGroupedByts, function ( key ) {
                        return key === 'Additional Details';
                    } );
                    if ( keysOfGroupedByts.length > 0 ) {
                        // if there is a ground, add it here
                        has.groundArrival.start = moment( keysOfGroupedByts[0].start ).add( 1, 'minute' ).toDate();

                        // insert the ground arrival before the first activity
                        $scope.groupedByts[keysOfGroupedByts[0]].unshift( has.groundArrival );
                    } else {
                        // there are no byts... soooo just use group start date
                        $scope.groupedByts[moment.tz( _.get( invite, 'experienceID.dateStart' ).split( 'T' )[0], invite.eventID.location.timezone ).format( 'YYYY-MM-DD' )] = [];
                    }
                }
            }

            // if the arrival text is enabled, add it after the hotel // unless there is a red eye flight
            if ( !_.get( invite, 'experienceID.itineraryDetails.isHideField.arrivalText' ) ) {
                var arrivalText = {
                    'type': 'arrivalText',
                    'header': _.get( invite, 'experienceID.itineraryDetails.headings.arrivalText.text', "You're Here!" ),
                    'fa': _.get( invite, 'experienceID.itineraryDetails.headings.arrivalText.icon', 'fa fa-heart' ),
                    // we now do substituion on arrival text BB-102
                    'details': $variableSubstitution.doSubstitutions( _.get( invite, 'experienceID.itineraryDetails.arrivalText' ) ),
                    'start': moment( hello ).add( 1, 'minute' ).format( 'YYYY-MM-DD HH:mm:ss' )
                };

                // make sure the groupedByts is there before adding or not
                if ( !$scope.groupedByts[hello] ) {
                    // this only happens if you have no activity byts. Yeah weird.
                    $scope.groupedByts[hello] = [];
                }

                // set arrival text to the right position
                $scope.groupedByts[hello].unshift( arrivalText );
            }

            // goodBye is the time the person is "time to go home"
            var goodBye = {};

            if ( airDepartureLegs.length > 0 ) {
                /*
                reorder the arrival flight legs
                goodBye will be the last of the legs, no matter what
                */
                airDepartureLegs = _.orderBy( airDepartureLegs, ['start'], ['asc'] );

                // set goodBye to before the first leg
                goodBye = moment( airDepartureLegs[0].start ).format( 'YYYY-MM-DD' );
            } else {
                // no hotel, air
                // so we will use the last activity as the goodbye date
                var lastActivity = _.findLast( orderedByts, function ( byt ) {
                    return ['Activity', 'Ticket'].indexOf( byt.type ) > -1;
                } );
                if ( lastActivity ) {
                    goodBye = moment.utc( lastActivity.start ).format( 'YYYY-MM-DD' );
                } else {
                    // use the group end date
                    goodBye = moment.utc( _.get( invite, 'experienceID.dateEnd' ) ).format( 'YYYY-MM-DD' );
                }
            }
            // groundDeparture stuff. Caution: do not go here if there is a value for bytID.bytDetails.pickupTime
            if ( has.groundDeparture && !_.get( has, 'groundDeparture.bytID.bytDetails.pickupTime.length', '' ) ) {
                if ( has.airDeparture ) {
                    var firstAirDepartureLeg = moment.utc( _.first( airDepartureLegs ).start ).format( 'YYYY-MM-DD' );
                    var firstAirDepartLegIndex = _.findIndex( $scope.groupedByts[firstAirDepartureLeg], function ( element ) {
                        return element.type === 'Air' && element.bytDetails.legs.type === 'return';
                    } );

                    $scope.groupedByts[firstAirDepartureLeg].splice( firstAirDepartLegIndex, 0, has.groundDeparture );
                } else {
                    // place the departure text in the right spot, basically on the last day of activity
                    var lastDayOfActivity = '';
                    lastDayOfActivity = _.find( orderedByts.reverse(), function ( byt ) { return byt.type === 'Activity'; } );

                    // if there are no activity byts, ust the event datestart
                    if ( !lastDayOfActivity ) {
                        lastDayOfActivity = {
                            'start': event.dateStart
                        };
                    }

                    // use the last day's activity or if there are no activities, use the experience end date
                    lastDayOfActivity = moment( _.get( lastDayOfActivity, 'start', _.get( invite, 'experienceID.dateEnd' ) ) ).format( 'YYYY-MM-DD' );

                    if ( !$scope.groupedByts[lastDayOfActivity] ) {
                        $scope.groupedByts[lastDayOfActivity] = [];
                    }

                    // put this at the last section
                    $scope.groupedByts[lastDayOfActivity].push( has.groundDeparture );
                }
            }

            // if there is a departure Text, show it
            if ( !_.get( invite, 'experienceID.itineraryDetails.isHideField.departureText' ) && _.get( invite, 'experienceID.itineraryDetails.departureText' ).length > 0 ) {
                var departureText = {
                    'type': 'departureText',
                    'header': _.get( invite, 'experienceID.itineraryDetails.headings.departureText.text', 'Time To Go Home' ),
                    'fa': _.get( invite, 'experienceID.itineraryDetails.headings.departureText.icon', 'fa fa-suitcase' ),
                    // we now do substituion on departure text BB-102
                    'details': $variableSubstitution.doSubstitutions( _.get( invite, 'experienceID.itineraryDetails.departureText' ) )
                };

                var departureTextPosition = 0;
                var activityPosition = 0;
                var departureTextAddAfter = 0;
                var activityCount = 0;
                var travelCount = 0;

                // figure out which position to place the departure text
                _.each( $scope.groupedByts[goodBye], function attachDepartureText ( item, index ) {
                    var attachable = false;
                    switch ( _.get( item, 'bytID.bytType' ) ) {
                        case 'travel':

                            // if this is a leg departure, then it is attachable
                            if ( _.get( item, 'bytDetails.legs.type' ) === 'departure' ) {
                                travelCount++;
                                attachable = true;
                            } else if ( _.get( item, 'bytID.bytDetails.direction' ) === 'departure' ) {
                                travelCount++;
                                // if this is a ground arrival, it is attachable
                                attachable = true;
                            }

                        break;
                    case 'ticket':
                    case 'activity':
                        // keep track of where the furthest down activity is
                        // just in case there are no travel byts. We would then add it AFTER the activity
                        activityCount++;

                            if ( index > activityPosition ) {
                                activityPosition = index;
                            }
                            break;
                        default:
                            if ( item.type === 'arrivalText' ) {
                                activityCount++;
                            }
                    }

                    if ( attachable ) {
                        if ( index > departureTextPosition ) {
                            departureTextPosition = index;
                        }
                    }
                } );

                // if there are no travelByts, but there is an activity byt, add the text after activity
                if ( !travelCount && activityCount ) {
                    departureTextPosition = activityPosition;
                    departureTextAddAfter = 1;
                }
                // make sure the groupedByts is there before adding or not
                if ( !$scope.groupedByts[goodBye] ) {
                    $scope.groupedByts[goodBye] = [];
                }
                // attach the time to go in the right spot
                $scope.groupedByts[goodBye].splice( departureTextPosition + departureTextAddAfter, 0, departureText );
            }
            /** ***************************************************************
             end of reordering the hotel, arrival/departure ground, and flights
             ******************************************************************/

            /*
                Add any byts bytsWithTimeTextStartOnly because depending if there is arrival anything,
                we need to place it at the top of the array or not
            */

            // put the bonus byts at the end of everything
            if ( bonusByts.length > 0 ) {
                $scope.groupedByts['Additional Details'] = bonusByts;
            }
            // for each date grouped byt with date time text start
            _.each( _.keys( bytsWithTimeTextStartOnly ), function ( date ) {
                // if there is date group that matches this date
                if ( groupedByts[date] ) {
                    var arrivalTextLocation = _.findIndex( groupedByts[date], {'type': 'arrivalText'} );
                    var arrivalAirLocation = _.findIndex( groupedByts[date], {'bytDetails': {'legs': {'type': 'departure'}}} );
                    var hotelLocation = _.findIndex( groupedByts[date], {'type': 'Hotel'} );
                    var arrivalGroundLocation = _.findIndex( groupedByts[date], {'bytID': {'bytDetails': {'direction': 'arrival'}}} );

                    if ( arrivalTextLocation >= 0 ) {
                        _.each( bytsWithTimeTextStartOnly[date], function ( byt ) {
                            $scope.groupedByts[date].splice( arrivalTextLocation + 1, 0, byt );
                        } );
                    } else if ( hotelLocation >= 0 ) {
                        _.each( bytsWithTimeTextStartOnly[date], function ( byt ) {
                            $scope.groupedByts[date].splice( hotelLocation + 1, 0, byt );
                        } );
                    } else if ( arrivalGroundLocation >= 0 ) {
                        _.each( bytsWithTimeTextStartOnly[date], function ( byt ) {
                            $scope.groupedByts[date].splice( arrivalGroundLocation + 1, 0, byt );
                        } );
                    } else if ( arrivalAirLocation >= 0 ) {
                        _.each( bytsWithTimeTextStartOnly[date], function ( byt ) {
                            $scope.groupedByts[date].splice( arrivalAirLocation + 1, 0, byt );
                        } );
                    } else {
                        _.each( bytsWithTimeTextStartOnly[date], function ( byt ) {
                            $scope.groupedByts[date].unshift( byt );
                        } );
                    }
                }
            } );

            $scope.inviteData = {
                'eventName': _.get( invite, 'eventID.name' ),
                'inviteType': _.get( invite, 'type' ),
                'itineraryHeadline': _.get( invite, 'experienceID.itineraryDetails.headline' ),
                'eventIntroMessage': _.get( invite, 'experienceID.itineraryDetails.introMessage', 'maybe just not set' )
            };

            _.each( $scope.inviteData, function ( v, k ) {
                $scope.inviteData[k] = $variableSubstitution.doSubstitutions( v );
            } );

            $scope.inviteData.headingInfo = _.get( invite, 'experienceID.itineraryDetails.headings' );

            // here we are adding !important to the colors so that when a browser/PDF generation sees the page, the colors stay
            _.each( $scope.inviteData.headingInfo, function ( head, key ) {
                var tempBackgroundColor = $scope.inviteData.headingInfo[key].backgroundColor;
                $scope.inviteData.headingInfo[key].backgroundColor = tempBackgroundColor + ' !important';

                var tempTextColor = $scope.inviteData.headingInfo[key].textColor;
                $scope.inviteData.headingInfo[key].textColor = tempTextColor + ' !important';
            } );

            // we give full trust that the code in our database is safe. Otherwise, we get some other issues with styling not being displayed properly
            $scope.trustedHtml = function ( plainText ) {
                return $sce.trustAsHtml( plainText );
            };
        }

        // HOTFIX FOR ORDERING NEED REVISIT
        for ( var key in groupedByts ) {
            var airArray = [];
            var airWithoutArray = [];
            groupedByts[ key ].forEach( function ( byt ) {
                if ( byt.type === 'Air' ) {
                    airArray.push( byt );
                } else {
                    airWithoutArray.push( byt );
                }
            } );
            airArray = airArray.sort( function ( a, b ) {
                if ( moment( a.startWithTZ ).isBefore( b.startWithTZ ) ) {
                    return -1;
                } else {
                    return 1;
                }
            } );
            if ( airWithoutArray.length > 0 ) {
                airArray.forEach( function ( airByt ) {
                    var injectIndex = 0;
                    airWithoutArray.forEach( function ( normalByt, index ) {
                        if ( normalByt.type !== 'Air' ) {
                            if ( normalByt.start && moment( airByt.start ).isAfter( normalByt.start ) ) {
                                injectIndex = index + 1;
                            }
                        } else {
                            if ( moment( airByt.startWithTZ ).isAfter( normalByt.startWithTZ ) ) {
                                injectIndex = index + 1;
                            }
                        }
                    } );
                    airWithoutArray.splice( injectIndex, 0, airByt );
                } );
                groupedByts[ key ] = airWithoutArray;
            } else if ( airArray.length > 0 ) {
                groupedByts[ key ] = airArray;
            }
        }

        // Workaround for make right order for hello text
        var keyWithHello = null;
        var keyWithHotel = null;
        var helloKeyIndex = -1;
        var hotelKeyIndex = -1;
        var helloByt = null;
        var keyWithAir = null;
        var airKeyIndex = -1;

        // looking for helo test
        for ( var key in groupedByts ) {
            groupedByts[ key ].forEach( function ( byt, index ) {
                if ( byt.type === 'arrivalText' ) {
                    keyWithHello = key;
                    helloKeyIndex = index;
                }
            } );
        }
        // Pulling out from ordered array hello text
        if ( helloKeyIndex > -1 ) {
            helloByt = groupedByts[ keyWithHello ].splice( helloKeyIndex, 1 );
        }

        // Getting right indexes for hotel and air
        for ( var key in groupedByts ) {
            groupedByts[ key ].forEach( function ( byt, index ) {
                if ( byt.type === 'Hotel' && ( !keyWithHotel || keyWithHotel > key ) ) {
                    keyWithHotel = key;
                    hotelKeyIndex = index;
                }
                if ( byt.type === 'Air' && ( !keyWithAir || keyWithAir > key ) ) {
                    keyWithAir = key;
                }
            } );
        }

        // Adding hello text in right position
        if ( helloKeyIndex > -1 && hotelKeyIndex > -1 ) {
            groupedByts[ keyWithHotel ].splice( hotelKeyIndex, 0, helloByt[ 0 ] );
        } else if ( helloKeyIndex > -1 && keyWithAir ) {
            groupedByts[ keyWithAir ].forEach( function ( byt, index ) {
                if ( byt.type === 'Air' && byt.bytDetails.legs.type === 'departure' ) {
                    airKeyIndex = index;
                }
            } );
            groupedByts[ keyWithAir ].splice( airKeyIndex + 1, 0, helloByt[ 0 ] );
        } else if ( helloKeyIndex > -1 ) {
            groupedByts[ keyWithHello ].unshift( helloByt[ 0 ] );
        }

        if ( $scope.invite.customOrdering && $scope.invite.customOrdering.enabled && $scope.invite.customOrdering.byts ) {
            var customGroupedByts = {};
            $scope.invite.customOrdering.byts.sort( function ( first, second ) {
                if ( first.date > second.date ) {
                    return 1;
                }
                if ( first.date < second.date ) {
                    return -1;
                }

                return first.order - second.order;
            } ).forEach( function ( customByt ) {
                Object.keys( groupedByts ).forEach( function ( key ) {
                    groupedByts[key].forEach( function ( byt, index ) {
                        if ( ( ['arrivalText', 'departureText'].includes( customByt.type ) && byt.type === customByt.type ) || ( byt.bytID && byt.bytID.id === customByt.bytID && ( byt.type !== 'Air' || byt.bytDetails.legs.legID === customByt.itemID ) ) ) {
                            if ( !customGroupedByts[customByt.date] ) {
                                customGroupedByts[customByt.date] = [];
                            }

                            var newByt = angular.copy( byt );
                            newByt.order = customByt.order;
                            customGroupedByts[customByt.date].push( newByt );
                            groupedByts[key].splice( index, 1 );
                        }
                    } );
                } );
            } );

            Object.keys( groupedByts ).forEach( function ( date ) {
                if ( groupedByts[date].length ) {
                    if ( !customGroupedByts[date] ) {
                        customGroupedByts[date] = [];
                    }
                    groupedByts[date].forEach( function ( byt ) {
                        var order = null;
                        customGroupedByts[date].forEach( function ( customByt, customIndex ) {
                            if ( byt.start < customByt.start && order === null ) {
                                order = customIndex;
                            }
                        } );
                        if ( order === null ) {
                            order = customGroupedByts[date].length;
                        }
                        customGroupedByts[date].splice( order, 0, byt );
                    } );
                }
            } );

            groupedByts = customGroupedByts;
        }

        // erase any empty dates and sort by dates
        tempGroupedByts = {};
        Object.keys( groupedByts ).sort().forEach( function ( key ) {
            if ( groupedByts[key].length ) {
                tempGroupedByts[key] = groupedByts[key];
            }
        } );
        groupedByts = tempGroupedByts;

        $scope.groupedByts = groupedByts;
    }] );
